import { toast } from 'react-toastify'
import { useMutation, UseMutationResult } from '@tanstack/react-query'
import { InvoiceForm } from 'models/invoices.models'
import { STORE_EVENT_TYPES } from 'lib/enums/shared.enums'
import { errorToastOptions, successToastOptions } from 'lib/utils/toast.utils'
import { useAppDispatch } from 'store/hooks'
import { setStoreEvent } from 'store/StoreEvent/storeEvent.reducer'
import { IApiError } from 'services/Shared/shared.models'
import { saveInvoiceCreationProgress } from 'services/Invoices/invoices.services'

const useSaveInvoiceCreationProgress = (
  activeWorkspace: number,
  cleanUpAndLeave: (backToInvoices?: boolean) => void
): UseMutationResult<void, IApiError, InvoiceForm> => {
  const dispatch = useAppDispatch()

  const mutation = useMutation<void, IApiError, InvoiceForm>(
    form => saveInvoiceCreationProgress(activeWorkspace, form),
    {
      onSuccess: () => {
        dispatch(setStoreEvent(STORE_EVENT_TYPES.SWITCH_INVOICE_DRAFTS_TAB))
        cleanUpAndLeave(true)
        toast.success(
          'Borrador de CFDI guardado con éxito',
          successToastOptions
        )
      },
      onError: () => {
        toast.error(
          'No fue posible guardar el borrador. Por favor intenta de nuevo más tarde',
          errorToastOptions
        )
      },
    }
  )

  return mutation
}

export default useSaveInvoiceCreationProgress
